/**
 * Tabs Component.
 * For toggle tab; switch experience between personal, business and others
 * toggle labelArray data struture
 *  [{
 *    key,
 *    label,
 *    priority,
 *    href,
 *  }, ...]
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _toNumber from 'lodash/toNumber';
import { SegmentedController, SegmentedControllerPanel } from '@paypalcorp/pp-react';

// Helper
import { trackLink } from '../../../lib/analytics-helper';
import { TAB } from '../../constants/PropTypesShapes';

class Tabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.selected,
    };

    // binding this function
    this.handleClick = this.handleClick.bind(this);
  }

  // Handle Click event with Tracking FPTI as a Param.
  handleClick(e, index) {
    e.preventDefault();
    this.setState({
      selected: index,
    });
    const tabList = this.sortTabNameList();
    const tab = tabList.filter((item) => item.priority === parseInt(index, 10))[0];
    if (tab.href) {
      window.location.href = tab.href;
    }
    if (this.props.trackLink && this.props.trackLink.id && this.props.trackLink.link) {
      trackLink(this.props.trackLink);
    }
    if (this.props.onClick) {
      this.props.onClick(tab);
    }
  }

  // Sort the display sequence by priority index
  sortTabNameList() {
    return this.props.labelArray.sort((tab1, tab2) => _toNumber(tab1.priority) - _toNumber(tab2.priority));
  }

  // render content toggles with container
  renderTabs() {
    return (
      <SegmentedController
        name="TabsGroup1"
        selectedTabIdx={this.state.selected}
        tabs={this.sortTabNameList()}
        className="segmented-tabs-container"
        onClick={(e, index) => this.handleClick(e, index)}
      >
        {this.sortTabNameList().map((item) => {
          return <SegmentedControllerPanel id={item.priority} className="segmented-controller-panel" />;
        })}
      </SegmentedController>
    );
  }

  render() {
    return <div className={this.props.className}>{this.renderTabs()}</div>;
  }
}

// Tabs Props Types.
Tabs.propTypes = {
  className: PropTypes.string,
  labelArray: PropTypes.arrayOf(PropTypes.shape(TAB)).isRequired,
  onClick: PropTypes.func,
  trackLink: PropTypes.shape({
    id: PropTypes.string,
    link: PropTypes.string,
  }),
  selected: PropTypes.number,
};

Tabs.defaultProps = {
  className: 'tabs-container',
  onClick: () => {},
  trackLink: {},
  selected: 0,
};

export default Tabs;
